import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import SliceData from "../SliceData";
import Limit from "../Limit";
import NoiseRemoval from "../NoiseRemoval";
import { Typography } from "@mui/material";
import Projectcolors from "../../Utils/Colors";
import { Button,IconButton } from "@mui/material";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import EditIcon from "@mui/icons-material/Edit";
import Paper from "@mui/material/Paper";
import LinearProgress from "@mui/material/LinearProgress";
import Modal from "@mui/material/Modal";
import LinePlotRaw from "../LinePlotRaw";
import Tab from "@mui/material/Tab";
import Heatmap from "../Heatmap";
import Scatterplot from "../Scatterplot";
import CloseIcon from "@mui/icons-material/Close";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import GlobalLoader from "../CommonC/GlobalLoader";
import { baseURL } from "../../Config/config";
import Spearman from "../Spearman";

function Cleandata(props) {
  const [value, setValue] = React.useState("1");
  const [openrawdata, setOpenrawdata] = React.useState(false);
  const [openslicedata, setOpenslicedata] = React.useState(false);
  const [openlimitdata, setOpenlimitdata] = React.useState(false);
  const [opennoisedata, setOpennoisedata] = React.useState(false);
  const [percentage, setPercentage] = React.useState(70);
  const [getLoader, setGetLoader] = React.useState(false);
  const [timeseries, setTimeseries] = React.useState(0);

  useEffect(() => {
    getPercentage();
  }, []);
  // const CustomTab = withStyles({
  //   root: {
  //     textTransform: "none"
  //   }
  // })(Tab);

  const getPercentage = () => {
    setGetLoader(true);
    const ProjectID = sessionStorage.getItem("projectID");
    fetch(
      `${baseURL}/getpercentage?projectID=${ProjectID}&loaded=${props.loaded}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())

      .then((data) => {
        setPercentage(data.percentage);
        setTimeseries(data.timeseries);
        setGetLoader(false);
      })
      .catch((err) => {
        setGetLoader(false);
        console.log("caught it!", err);
      });
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handlerawdataOpen = () => setOpenrawdata(true);
  const handlerawdataClose = () => {
    setOpenrawdata(false);
    getPercentage();
  };
  const handleslicedataOpen = () => setOpenslicedata(true);
  const handleslicedataClose = () => {
    setOpenslicedata(false);
    getPercentage();
  };
  const handlelimitdataClose = () => setOpenlimitdata(false);
  const handlelimitdataOpen = () => setOpenlimitdata(true);
  const handlenoisedataClose = () => {
    setOpennoisedata(false);
    getPercentage();
  };
  const handlenoisedataOpen = () => setOpennoisedata(true);

  const NextStep = () => {
    props.handleNextStep();
  };

  return (
    <div>
      <Card
  elevation={0}
  sx={{
    width: "90%",
    mx: "auto",
    mt: "30px",
    border:2,
    borderColor:"#0078c9",
    borderRadius: "24px",
    background:
      "linear-gradient(180deg,#ffffff 0%, rgba(240,248,255,0.8) 100%)",
    boxShadow: "0px 10px 40px rgba(0,0,0,0.08)",
    overflow: "hidden",
  }}
>
  {/* Header */}
  <Box
    sx={{
      px: 4,
      py: 2,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderBottom: "1px solid rgba(0,0,0,0.06)",
    }}
  >
    <Box>
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: 600,
          color: "#0078c9",
        }}
      >
        Data Conditioning
      </Typography>

      <Typography
        sx={{
          fontSize: "12px",
          color: "#777",
          mt: .5
        }}
      >
        Process and prepare your dataset
      </Typography>
    </Box>

    <Box
      sx={{
        bgcolor: "rgba(0,120,201,.08)",
        color:"#0078c9",
        px:2,
        py:.7,
        borderRadius:"20px",
        fontSize:"12px",
        fontWeight:600
      }}
    >
      4 Steps
    </Box>
  </Box>


  <Box sx={{p:3}}>

    {[
      {
        title:"Raw Data Visualization",
        action:handlerawdataOpen
      },
      {
        title:"Data Slicing",
        action:handleslicedataOpen
      },
      {
        title:"Engineering Constraint",
        action:handlelimitdataOpen
      },
      {
        title:"Data Noise Removal",
        action:handlenoisedataOpen
      }
    ].map((item,index)=>(

      <Paper
        key={index}
        elevation={0}
        sx={{
          p:2,
          mb:2,
          borderRadius:"18px",
          bgcolor:"#fff",
          transition:".3s",
          border:"1px solid rgba(0,120,201,.08)",

          "&:hover":{
            transform:"translateY(-3px)",
            boxShadow:"0 10px 30px rgba(0,0,0,.08)"
          }
        }}
      >

        <Box
          sx={{
            display:"flex",
            alignItems:"center",
            gap:2
          }}
        >

          <Box
            onClick={item.action}
            sx={{
              width:42,
              height:42,
              borderRadius:"12px",
              bgcolor:"rgba(158,11,34,.08)",
              display:"flex",
              alignItems:"center",
              justifyContent:"center",
              cursor:"pointer"
            }}
          >
            <EditIcon
              sx={{
                color:"#9e0b22",
                fontSize:18
              }}
            />
          </Box>


          <Box sx={{flex:1}}>

            <Typography
              sx={{
                fontSize:"12px",
                fontWeight:600
              }}
            >
              {item.title}
            </Typography>

            <Box
              sx={{
                display:"flex",
                alignItems:"center",
                mt:1
              }}
            >
              <LinearProgress
                variant="determinate"
                value={percentage}
                sx={{
                  flex:1,
                  height:8,
                  borderRadius:"10px",

                  background:"#eaf4fb",

                  "& .MuiLinearProgress-bar":{
                    background:"#0078c9"
                  }
                }}
              />

              <Typography
                sx={{
                  ml:2,
                  fontSize:"12px",
                  fontWeight:600,
                  color:"#9e0b22"
                }}
              >
                {percentage}%
              </Typography>

            </Box>

          </Box>

        </Box>

      </Paper>

    ))}

  </Box>
</Card>

      <Paper elevation={0} >
        <Modal open={openrawdata} onClose={handlerawdataClose} elevation={0}>
           <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",

      width: 950,
      height: 700,

      bgcolor: "#fff",
      borderRadius: "22px",

      overflow: "hidden", // important
      display: "flex",
      flexDirection: "column",

      boxShadow: "0px 15px 50px rgba(0,0,0,.15)",
    }}
  >
            <div>
              <Box
      sx={{
        px: 3,
        py: 1.2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        background:
          "linear-gradient(90deg,#0078c9,#0d8fe6)",
      }}
    >

<Typography
sx={{
fontSize:"16px",
fontWeight:600,
color:"#fff"
}}
>
Raw Data Visualization
</Typography>

<IconButton onClick={handlerawdataClose}>
<CloseIcon sx={{color:"#fff"}}/>
</IconButton>

</Box>
            </div>

           <TabContext value={value}>
  <Box
    sx={{
      width: "92%",
      mx: "auto",
      mt: 2,
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        p: 1,
        bgcolor: "#f5f9fc",
        borderRadius: "18px",
        width: "fit-content",
        mx: "auto",
        boxShadow: "0px 4px 20px rgba(0,0,0,.05)",
      }}
    >
      <TabList
        onChange={handleChange}
        aria-label="tabs"

        TabIndicatorProps={{
          style: {
            display: "none",
          },
        }}

        sx={{
          minHeight: "25px",

          "& .MuiTabs-flexContainer": {
            gap: "8px",
          },

          "& .MuiTab-root": {
            minHeight: "30px",
            fontSize: "12px",
            textTransform: "none",
            color: "#666",
            borderRadius: "12px",
            px: 1,
            transition: ".3s",
            fontWeight: 500,
          },

          "& .Mui-selected": {
            background:
              "linear-gradient(90deg,#0078c9,#1c96ea)",
            color: "#fff !important",
            boxShadow:
              "0 8px 20px rgba(0,120,201,.3)",
          }
        }}
      >
        <Tab label="Data" value="1" />

        <Tab label="Correlation" value="2" />

        <Tab label="Plot Controls" value="3" />

        <Tab label="MB Ranking" value="4" />
      </TabList>
    </Box>


    <Box
      sx={{
        mt: 1,
        p: 2,
        borderRadius: "22px",
        bgcolor: "#fff",
        minHeight: "430px",

        boxShadow:
          "0px 8px 30px rgba(0,0,0,.06)"
      }}
    >
      <TabPanel
        value="1"
        sx={{p:0}}
      >
        <LinePlotRaw />
      </TabPanel>

      <TabPanel
        value="2"
        sx={{p:0}}
      >
        <Heatmap />
      </TabPanel>

      <TabPanel
        value="3"
        sx={{p:0}}
      >
        <Scatterplot />
      </TabPanel>

      <TabPanel
        value="4"
        sx={{p:0}}
      >
        <Spearman />
      </TabPanel>
    </Box>
  </Box>
</TabContext>
          </Box>
        </Modal>
      </Paper>

      <Paper elevation={3}>
        <Modal open={openslicedata} onClose={handleslicedataClose}>
            <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",

      width: 950,
      height: 700,

      bgcolor: "#fff",
      borderRadius: "22px",

      overflow: "hidden", // important
      display: "flex",
      flexDirection: "column",

      boxShadow: "0px 15px 50px rgba(0,0,0,.15)",
    }}
  >
            <div>
                <Box
      sx={{
        px: 3,
        py: 1.2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        background:
          "linear-gradient(90deg,#0078c9,#0d8fe6)",
      }}
    ><Typography
sx={{
fontSize:"16px",
fontWeight:600,
color:"#fff"
}}
>
                  Data Slicing
                </Typography>
                
<IconButton onClick={handleslicedataClose}>
<CloseIcon sx={{color:"#fff"}}/>
</IconButton>

              </Box>
            </div>

            <SliceData editAccess={props.editAccess} />
          </Box>
        </Modal>
      </Paper>

      <Paper elevation={3}>
        <Modal open={openlimitdata} onClose={handlelimitdataClose}>
         <Box
    sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",

      width: 950,
      height: 700,

      bgcolor: "#fff",
      borderRadius: "22px",

      overflow: "hidden", // important
      display: "flex",
      flexDirection: "column",

      boxShadow: "0px 15px 50px rgba(0,0,0,.15)",
    }}
  >
            <div>
              <Box
      sx={{
        px: 3,
        py: 1.2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        background:
          "linear-gradient(90deg,#0078c9,#0d8fe6)",
      }}
    >

<Typography
sx={{
fontSize:"16px",
fontWeight:600,
color:"#fff"
}}
>
Data Check Limit</Typography>

<IconButton onClick={handlelimitdataClose}>
<CloseIcon sx={{color:"#fff"}}/>
</IconButton>

</Box>
            </div>

            <Limit
              editAccess={props.editAccess}
              loaded={props.loaded}
              ProjectID={props.ProjectID}
            />
          </Box>
        </Modal>
      </Paper>

      <Paper elevation={3}>
        <Modal open={opennoisedata} onClose={handlenoisedataClose}>
          <Box
            sx={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",

      width: 950,
      height: 700,

      bgcolor: "#fff",
      borderRadius: "22px",

      overflow: "hidden", // important
      display: "flex",
      flexDirection: "column",

      boxShadow: "0px 15px 50px rgba(0,0,0,.15)",
    }}
          >
            <div>
            <Box
      sx={{
        px: 3,
        py: 1.2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",

        background:
          "linear-gradient(90deg,#0078c9,#0d8fe6)",
      }}
    >

<Typography
sx={{
fontSize:"16px",
fontWeight:600,
color:"#fff"
}}
>
Data Noise Removal</Typography>

<IconButton onClick={handlenoisedataClose}>
<CloseIcon sx={{color:"#fff"}}/>
</IconButton>

</Box>
            </div>

            <NoiseRemoval editAccess={props.editAccess} />
          </Box>
        </Modal>
      </Paper>

      <Button
        onClick={NextStep}
        mt={5}
        sx={{
          float: "right",
          marginRight: 15,
          width: 10,
          height: 35,
          fontSize: 16,
          marginTop: 5,
          backgroundColor: Projectcolors.primary,
          color: "black",
          fontStyle: "bold",
        }}
        variant="contained"
        size="large"
      >
        {" "}
        <ChevronRightIcon sx={{ fontSize: "25px", color: "white" }} />
      </Button>

      <Box
        sx={{
          margin: "auto",
          width: "80%",
          typography: "h5",
          backgroundColor: "grey",
        }}
      >
        {/*<TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider',fontSize:35 }}>
          <TabList onChange={handleChange} sx={{width:'50%',textAlign:'center',marginTop:3,fontSize:35}} aria-label="lab API tabs example">
            <Tab sx={{fontSize:15}} label="Raw Data" value="1" />
            <Tab sx={{fontSize:15}} label="Slicing" value="2" />
            <Tab  sx={{fontSize:15}} label="Check Limit" value="3" />

            <Tab sx={{fontSize:15}} label="Noise Removal" value="4" />
          </TabList>
        </Box>
        <TabPanel value="1" ><RawData /></TabPanel>
        <TabPanel value="2"><SliceData /></TabPanel>
        <TabPanel value="3"><Limit /></TabPanel>
        <TabPanel value="4"><NoiseRemoval /></TabPanel>

</TabContext>*/}
      </Box>
      {getLoader ? <GlobalLoader /> : null}
    </div>
  );
}

export default Cleandata;
